import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
	providedIn: 'root'
})
export class ErrorService {

	public errors: BehaviorSubject<any> = new BehaviorSubject<any>(null);

	public setError(error: any) {
		this.errors.next(error);
	}
}